const options = {}

const trackPage = (page) => {
  console.log("GA tracking page", page);
  window.gtag('config', window.appConfig.ga, {
    'page_title' : window.title,
    'page_path': page
  });
}

let currentPage = ''

export const googleAnalytics = store => next => action => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    const nextPage = `${action.payload.location.pathname}${action.payload.location.search}`

    if (currentPage !== nextPage) {
      currentPage = nextPage
      trackPage(nextPage)
    }
  }

  return next(action)
}
